import React, { useEffect, useState } from "react";
import { AlertTriangle, ChevronDown, MessageCircle } from "lucide-react";
import { api } from "../../lib/api";
import { fmtFecha } from "./UserFichaDialog";

const waLink = (n) => `https://wa.me/${(n || "").replace(/\D/g, "")}`;

const Lista = ({ items, testid, onOpen, showDias }) => (
  <div data-testid={testid} className="mt-2 max-h-72 overflow-y-auto divide-y divide-black/5 rounded-xl bg-white ring-1 ring-black/5">
    {items.length === 0 && <p className="px-4 py-3 text-sm text-[#6B7688]">Nadie en esta lista.</p>}
    {items.map((u) => (
      <div key={u.id} className="px-4 py-2.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
        <button data-testid={`inactivo-${u.email}`} onClick={() => onOpen(u.id)} className="font-bold text-[#0A1C30] hover:text-[#3B7DF6] text-left">{u.nombre} {u.apellidos}</button>
        <span className="text-xs text-[#6B7688]">{u.programa || "Sin programa"}{u.grupo ? ` · Grupo ${u.grupo}` : ""}</span>
        {showDias && <span className="text-xs font-bold text-[#C0392B]">{u.dias} días sin entrar · {fmtFecha(u.last_access)}</span>}
        {u.whatsapp && <a href={waLink(u.whatsapp)} target="_blank" rel="noreferrer" className="ml-auto inline-flex items-center gap-1 text-xs font-bold text-[#22A860]"><MessageCircle className="w-3.5 h-3.5" /> {u.whatsapp}</a>}
      </div>
    ))}
  </div>
);

export const InactividadAlert = ({ onOpen }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("inactivos");
  useEffect(() => { api.get("/admin/users/inactivos", { params: { dias: 3 } }).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const n = d.inactivos.length, s = d.sin_registro.length;
  return (
    <div data-testid="inactividad-alert" className={`mt-4 rounded-2xl ring-1 p-4 ${n ? "bg-[#FDECEA] ring-[#C0392B]/30" : "bg-[#E2F6EB] ring-[#22A860]/30"}`}>
      <button data-testid="inactividad-toggle" onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-3 text-left">
        <AlertTriangle className={`w-5 h-5 shrink-0 ${n ? "text-[#C0392B]" : "text-[#22A860]"}`} />
        <div className="flex-1">
          <p className="font-extrabold text-[#0A1C30] text-sm sm:text-base"><span data-testid="inactividad-count">{n}</span> usuario(s) llevan más de 3 días sin entrar a la app</p>
          <p className="text-xs text-[#6B7688]"><span data-testid="sin-registro-count">{s}</span> más aún no tienen registro de acceso. Toca para ver la lista y darles seguimiento.</p>
        </div>
        <ChevronDown className={`w-5 h-5 text-[#6B7688] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-3">
          <div className="flex gap-2">
            {[["inactivos", `Más de 3 días (${n})`], ["sin", `Sin registro de acceso (${s})`]].map(([k, l]) => (
              <button key={k} data-testid={`inactividad-tab-${k}`} onClick={() => setTab(k)} className={`rounded-full px-3 py-1.5 text-xs font-bold transition-colors ${tab === k ? "bg-[#0A1C30] text-white" : "bg-white text-[#0A1C30] ring-1 ring-black/10"}`}>{l}</button>
            ))}
          </div>
          {tab === "inactivos" ? <Lista items={d.inactivos} testid="inactivos-list" onOpen={onOpen} showDias /> : <Lista items={d.sin_registro} testid="sin-registro-list" onOpen={onOpen} />}
        </div>
      )}
    </div>
  );
};
